export default __webpack_public_path__ + "static/media/nameicon.0adc2feb.svg";